module.exports = __webpack_public_path__ + "media/src/images/certificate_sample-2e84e8090d6bb35b9287773335321918.jpg";